// Import the locale messages (or use lazy loading if preferred)
import { createI18n } from 'vue-i18n'

type Locale = 'id' | 'en'

import en from './locales/en.json'
import id from './locales/id.json'

function getBrowserLocale(key: string): Locale {
  const value = localStorage.getItem(key)
  let parse = null

  if (typeof value === 'string') {
    parse = JSON.parse(value) // ok
  } else {
    return 'id'
  }

  if (parse.currentLocale === 'id' || parse.currentLocale === 'en') {
    return parse.currentLocale as Locale
  }
  return 'id'
}

// Create the i18n instance
export const i18n = createI18n({
  locale: getBrowserLocale('locale'), // Default locale
  fallbackLocale: getBrowserLocale('locale'), // Fallback locale
  warnHtmlMessage: false,
  messages: {
    id,
    en
  }
})
